import { render, staticRenderFns } from "./CreateAddonForm.vue?vue&type=template&id=7cf4b4e1"
import script from "./CreateAddonForm.vue?vue&type=script&lang=js"
export * from "./CreateAddonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports